import axios from 'axios';
import * as Sentry from '@sentry/react';

const isRefusal = (error: unknown) => {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined;
  return status !== undefined && status >= 400 && status < 500;
};

export const reportUnexpected = (error: unknown) => {
  if (!isRefusal(error)) Sentry.captureException(error);
};
